import { VueModule } from '@Foundation';
import ProductBattle from './code/Scripts/components/product-battle';

export default VueModule({
  components: {
    ProductBattle
  }
});
